<template>
  <b-card class="cardStyle p-2">
    <p class="menu-header">
      <b-icon icon="menu-button-wide-fill" scale="1.3"></b-icon>&nbsp;&nbsp; Manage Study-Site
      Access
    </p>
    <div
      v-for="link in links"
      :key="link.title"
      :class="menuOption === link.route ? 'access-manager-active' : 'access-manager-inactive'"
      @click="replaceRoute(link.route)"
    >
      {{ link.title }}
    </div>
    <hr class="solid my-2" />
    <div
      :class="
        menuOption === 'view-study-access-requests'
          ? 'access-manager-active'
          : 'access-manager-inactive'
      "
      :style="this.$route.name.includes('ticket') ? 'pointer-events: unset' : ''"
      @click="replaceRoute('view-study-access-requests')"
    >
      View Study-Site Access Requests
    </div>
  </b-card>
</template>

<script>
  export default {
    props: {
      menuOption: String,
    },
    data() {
      return {
        links: [
          {
            title: 'My Access',
            route: 'my-access',
          },
          {
            title: 'My Team',
            route: 'my-team',
          },
        ],
      };
    },
    computed: {
      isEnrollmentOversight() {
        return this.$route.name.includes('oversight');
      },
    },
    methods: {
      replaceRoute(selected) {
        this.$router.replace({
          name: this.isEnrollmentOversight ? 'oversight-application-access' : 'application-access',
          query: {
            option: selected,
          },
        });
      },
    },
  };
</script>

<style scoped>
  .access-manager-active {
    background: #f4eff4;
    color: #4040d7;
    border: 0;
    border-radius: 32px;
    padding: 10px 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    margin-top: 0.5rem;
    pointer-events: none;
  }

  .access-manager-inactive {
    background: #fffbfe;
    color: #0b0a0e;
    border: 0;
    border-radius: 32px;
    padding: 10px 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    margin-top: 0.5rem;
  }

  .menu-header {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #0060aa;
  }
</style>
